declare global {
	interface Window {
		__backendOriginHost: string | undefined;
	}
}

export const getOrigin = ({ location, __backendOriginHost }: Window & typeof globalThis) =>
	location.hostname === 'localhost' ? `https://${__backendOriginHost}` : location.origin;
